// extracted by mini-css-extract-plugin
module.exports =  {"root":"omLewwNPyqQLzai5mg61"};